module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toch"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "ptt"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("Chapter 1      A EUNUCH SLAVE’S LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2"
    }
  }, [_vm._v("Chapter 2      OBLIGATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3"
    }
  }, [_vm._v("Chapter 3      A DREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4"
    }
  }, [_vm._v("Chapter 4      THE LONELY ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5"
    }
  }, [_vm._v("Chapter 5      THE RULER OF THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6"
    }
  }, [_vm._v("Chapter 6      PURIFICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter7"
    }
  }, [_vm._v("Chapter 7      THE PEOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter8"
    }
  }, [_vm._v("Chapter 8      JOINING HEAVEN AND EARTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter9"
    }
  }, [_vm._v("Chapter 9      GOVERNMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10    A EUNUCH SLAVE’S WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11    A EUNUCH SLAVE’’S DISCIPLINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12    THE LAST YEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13    THE GREAT ANNUAL SACRIFICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14    FEAST AND PROCLAMATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15    THE HEART OF WE WHO SERVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16    CONTINUITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17    THE FIRST YEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18    SCHEDULE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19    THE QUOTIDIAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20    A EUNUCH SLAVE’S WAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21    THE SECOND, THIRD AND FOURTH YEARS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22    THE KARMAPA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23    THE FIFTH THROUGH EIGHTH YEARS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24    WORDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25    WORDS AND A EUNUCH SLAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26    THE ASPIRATION OF A EUNUCH SLAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27    NINTH THROUGH FIFTEENTH YEARS: 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28    AUDIENCE WITH GRAND SECRETARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29    NINTH THROUGH FIFTEENTH YEARS: 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30    DICTATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ch30_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1- NIGHTMARE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ch30_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2- LAW AND PUNISHMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31    THE LORD OF DEATH")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32    SIXTEENTH THROUGH EIGHTEENTH YEARS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33    STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34    FIRST OFFERING TO HEAVEN IN BEIJING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35    DICTATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36    NINETEENTH YEAR: 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37    NINETEENTH YEAR: 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38    DICTATION - REALITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39    TWENTIETH AND TWENTY - FIRST YEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40    A EUNUCH SLAVE’S FAREWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41    THE LAST YEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42    THE LAST DICTATION - OCEAN OF FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43    A EUNUCH SLAVE’S DREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2c63fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nameoftocfile.vue
// module id = 66
// module chunks = 0